export const stateSyntax = CSS.supports("selector(:state(checked))");
export const hasCSSSelectorSupport = CSS.supports("selector(:has(*))");
export const adoptedStyleSheetsSupport = "adoptedStyleSheets" in document;
